//request.js
import axios from "axios";
import {
	Message,
	MessageBox,
	Notification
} from 'element-ui'

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueRoute from 'vue-router'
import router from '@/utils/router.js'

//引入重复请求
import {
	useStDuplicateRequestAxios
} from "st-duplicate-request-axios"
const duplicateRequest = useStDuplicateRequestAxios(axios)



import jsCookie from 'js-cookie'

import {
	message
} from '@/utils/resetMessage';

import {
	setbaseurl
} from "@/utils/utils"

import {
	getToken
} from '@/utils/auth'

// console.log(window,"httpwindow")
/****** 创建axios实例 ******/
// 开发地址 192.168.88.136
// 生产地址，101.34.17.168:8091
// var env = process.env.NODE_ENV
//var baseURL = process.env.VUE_APP_BASE_URL

var baseURL = ""
baseURL = window.myURL.URL


// console.log("获取$router实例")
// console.log(router.push,"获取$router实例")

const service = axios.create({
	baseURL: baseURL, // api的base_url
	timeout: 20000 // 请求超时时间
});

// 函数返回唯一的请求key
function getRequestKey(config) {
	let {
		method,
		url,
		params,
		data
	} = config;
	return [method, url, JSON.stringify(params), JSON.stringify(data)].join("&");
}
let pendingRequest = new Map();

function addPendingRequest(config) {
	let requestKey = getRequestKey(config);
	config.cancelToken = config.cancelToken || new axios.CancelToken((cancel) => {
		if (!pendingRequest.has(requestKey)) {
			pendingRequest.set(requestKey, cancel);
		}
	});
}

function removePendingRequest(config) {
	let requestKey = getRequestKey(config);
	if (pendingRequest.has(requestKey)) {
		// 如果是重复的请求，则执行对应的cancel函数
		let cancel = pendingRequest.get(requestKey);
		cancel(requestKey);
		// 将前一次重复的请求移除
		pendingRequest.delete(requestKey);
	}
}



// console.log(service.baseURL,"请求里面的")
/****** request拦截器==>对请求参数做处理 ******/

service.interceptors.request.use(
	config => {
		// duplicateRequest.addRequest(config) // 添加进请求队列
		// console.log(config,"提交")
		// config.headers["Content-Type"] = "multipart/form-data"
		if (getToken() && getToken().length > 30) {
			config.headers['Authorization'] = getToken()
		} else if (jsCookie.get("Token")) {
			config.headers['Authorization'] = "Bearer " + jsCookie.get("Token").split("&")[0].split("=")[1];
		}


		if (config.data instanceof FormData) {
			// 是FormData类型
			config.headers["Content-Type"] = 'multipart/form-data'
		} else {
			// 不是FormData类型
			config.headers["Content-Type"] = "application/json; charset=utf-8"
		}
		// // 检查是否存在重复请求，若存在则取消已发的请求
		// removePendingRequest(config);
		// // 把当前请求信息添加到pendingRequest对象中
		// addPendingRequest(config);


		return config
	},
	error => {
		Message.error("请求超时!");
		return Promise.reject(error)
	}
)

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1);
		if (c.indexOf(name) != -1) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

let nums = 0
// 响应拦截器
service.interceptors.response.use(response => {
	// duplicateRequest.removeRequest(response.config) // 移除请求队列
	// console.log(response,"响应拦截");
	const code = response.status
	const messages = response.data.msg
	const codes = response.data.code
	const datas = response.data.data
	// console.log(response, "响应正确")
	if (code == 401 && codes == -2) {
		message("用户信息已失效，请重新登录！")
		jsCookie.remove("allbtnlist")
		jsCookie.remove("/%sxtrguid/%")
		jsCookie.remove("sxsi_guid")
		localStorage.clear("token")
		localStorage.clear("siguid")
		localStorage.clear("uiguid")
		localStorage.clear()
		jsCookie.remove("Token")
		setTimeout(() => {
			location.href = '#/yunxuexipingtai/homesview/homesview'
		}, 200)
		return Promise.resolve(response)
	}

	if (code == 401) {
		message("用户未授权,请联系管理员赋予！")
		localStorage.clear("token")
		localStorage.clear("siguid")
		localStorage.clear("uiguid")
		localStorage.clear()
		return Promise.resolve(response)
	}



	if (code == 200 && codes == -1) {
		// console.log(response)
		if (datas == -2) {

		} else {
			message(messages)
		}
		return Promise.resolve(response)
	} else if (code !== 200) {
		return Notification.error({
			title: messages
		})
	}


	// console.log(response, "判断请求值响应错误")
	// removePendingRequest(response.config);


	return Promise.resolve(response)
}, error => {

	try {
		error
	} catch (ers) {
		console.error(ers);
	}


	var codeas = error.response.status ?? ""
	var messagea = error.response.data.msg ?? ""
	var codesb = error.response.data.code ?? ''


	if (error && error.message == "timeout of 10000ms exceeded") {
		Message.error('请求超时，正在刷新页面！！！')
		// hideScreenLoading(error.headers);
	}

	let errstr = JSON.stringify(error.response)

	window.sessionStorage.setItem('errstr', errstr)
	console.log(codesb, location.host)
	// debugger
	// && router.currentRoute.path !== '/user/logins'
	if (codeas == 401 && codesb == -2) {
		// console.log('我要在这里拿到routew',routetzs.push)
		// Message.error('获取用户信息失败，请重新登录！')
		jsCookie.remove("allbtnlist")
		jsCookie.remove("/%sxtrguid/%")
		jsCookie.remove("sxsi_guid")
		localStorage.clear("token")
		localStorage.clear("siguid")
		localStorage.clear("uiguid")
		localStorage.clear()
		jsCookie.remove("Token")
		location.href = '#/yunxuexipingtai/homesview/homesview'
		
	} else {
		// jsCookie.remove("allbtnlist")
		// jsCookie.remove("/%sxtrguid/%")
		// jsCookie.remove("sxsi_guid")
		// localStorage.clear("token")
		// localStorage.clear("siguid")
		// localStorage.clear("uiguid")
		// jsCookie.remove("Token")
		
	}

	if (codesb == -1) {
		jsCookie.remove("allbtnlist")
		jsCookie.remove("/%name/%")
		jsCookie.remove("sxsi_guid")
		localStorage.clear("token")
		localStorage.clear("siguid")
		localStorage.clear("uiguid")
		jsCookie.remove("Token")
		
	}


	return error.response
})


// 返出
export default service